import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  titleWrapper: {
    position: 'relative',
    padding: '16px 0 0',
    maxWidth: theme.space.basicDataMaxWidth,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  title: {
    marginTop: 16,
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
    },
  },
  subtitle: {
    marginTop: 8,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  }
}), { name: 'ProductWizardTitle' });
